<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <meta content="" name="description">
  <meta content="" name="keywords">

  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>

<body>



  <!--Main layout-->
  <main style="margin-top: 40px;">
    <div class="container pt-4"></div>
  </main>
  <!--Main layout-->
  <main id="main">

    <section style="margin-top: 40px;">
      <app-menu-compartido></app-menu-compartido>
      <div class="section-title" data-aos="fade-up">
        <h4 style="text-align: left; margin-left: 140px;">La demás información pública a que obliguen las disposiciones
          federales y
          la Ley General de Contabilidad Gubernamental,
          así como aquella que se genere por la ejecución del gasto público con recursos federales</h4>
      </div>
    </section>

    <!-- ======= Breadcrumbs ======= -->
    <section id="breadcrumbs" class="breadcrumbs">
      <div class="container">

        <div class="d-flex justify-content-between align-items-center">
          <ol>
            <li>Inicio</li>
            <li><a href="admin/articulo-8">Articulo 8</a></li>
            <li>Fracción XIV</li>
          </ol>
        </div>

      </div>
    </section><!-- End Breadcrumbs -->


    <section id="blog" class="blog" >
      <!-- ======= Inicio Seccion Carpetas por año ======= -->
      <div class="fondo2">
        <div id="scroll">

      <div class="panel-group" id="accordion" style="height:600px;width: 100%;">
          <div class="panel panel-default"> Información Financiera SEVAC
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#x"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2018</i></button>
              </h4>
            </div>
            <div id="x" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion1" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820181()" data-bs-toggle="collapse" data-bs-parent="#accordion1" href="#z"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="z" class="panel-collapse collapse in" data-bs-parent="#accordion1">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo18()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion18()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs18, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue18($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo18">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>

                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820182()" data-bs-toggle="collapse" data-bs-parent="#accordion1" href="#c"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="c" class="panel-collapse collapse in" data-bs-parent="#accordion1">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo18()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion18()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs18, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue18($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo18">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>

                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820183()" data-bs-toggle="collapse" data-bs-parent="#accordion1" href="#v"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre </i></button>
                    </h4>
                  </div>
                  <div id="v" class="panel-collapse collapse in" data-bs-parent="#accordion1">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo18()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion18()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs18, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue18($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo18">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>

                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820184()" data-bs-toggle="collapse" data-bs-parent="#accordion1" href="#b"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="b" class="panel-collapse collapse in" data-bs-parent="#accordion1">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo18()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion18()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs18, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue18($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo18">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>

                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>





              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#n"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2019</i></button>
              </h4>
            </div>
            <div id="n" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion2" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820191()" data-bs-toggle="collapse" data-bs-parent="#accordion2" href="#m"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="m" class="panel-collapse collapse in" data-bs-parent="#accordion2">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo19()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion19()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs19, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue19($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo19">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>

                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820192()" data-bs-toggle="collapse" data-bs-parent="#accordion2" href="#ñ"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="ñ" class="panel-collapse collapse in" data-bs-parent="#accordion2">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo19()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion19()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs19, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue19($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo19">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>

                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820193()" data-bs-toggle="collapse" data-bs-parent="#accordion2" href="#p"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="p" class="panel-collapse collapse in" data-bs-parent="#accordion2">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo19()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion19()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs19, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue19($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo19">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>

                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820194()" data-bs-toggle="collapse" data-bs-parent="#accordion2" href="#o"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="o" class="panel-collapse collapse in" data-bs-parent="#accordion2">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo19()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion19()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs19, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue19($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo19">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>

                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>



              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#i"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2020</i></button>
              </h4>
            </div>
            <div id="i" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion3" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820201()" data-bs-toggle="collapse" data-bs-parent="#accordion3" href="#u"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="u" class="panel-collapse collapse in" data-bs-parent="#accordion3">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo20()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion20()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs20, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue20($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo20">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820202()" data-bs-toggle="collapse" data-bs-parent="#accordion3" href="#y"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="y" class="panel-collapse collapse in" data-bs-parent="#accordion3">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo20()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion20()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs20, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue20($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo20">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820203()" data-bs-toggle="collapse" data-bs-parent="#accordion3" href="#t"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="t" class="panel-collapse collapse in" data-bs-parent="#accordion3">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo20()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion20()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs20, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue20($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo20">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820204()" data-bs-toggle="collapse" data-bs-parent="#accordion3" href="#r"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="r" class="panel-collapse collapse in" data-bs-parent="#accordion3">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo20()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion20()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs20, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue20($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo20">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>














              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#e"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2021</i></button>
              </h4>
            </div>
            <div id="e" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion4" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820211()" data-bs-toggle="collapse" data-bs-parent="#accordion4" href="#d"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="d" class="panel-collapse collapse in" data-bs-parent="#accordion4">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo21()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion21()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs21, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue21($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo21">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820212()" data-bs-toggle="collapse" data-bs-parent="#accordion4" href="#a"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="a" class="panel-collapse collapse in" data-bs-parent="#accordion4">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo21()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion21()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs21, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue21($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo21">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820213()" data-bs-toggle="collapse" data-bs-parent="#accordion4" href="#s"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="s" class="panel-collapse collapse in" data-bs-parent="#accordion4">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo21()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion21()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs21, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue21($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo21">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820214()" data-bs-toggle="collapse" data-bs-parent="#accordion4" href="#f"
                        style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="f" class="panel-collapse collapse in" data-bs-parent="#accordion4">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo21()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion21()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs21, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue21($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo21">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#a5"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2022</i></button>
              </h4>
            </div>
            <div id="a5" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion5" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820221()" data-bs-toggle="collapse" data-bs-parent="#accordion5"
                        href="#collapse21" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse21" class="panel-collapse collapse in" data-bs-parent="#accordion5">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo22()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion22()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs22, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue22($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo22">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820222()" data-bs-toggle="collapse" data-bs-parent="#accordion5"
                        href="#collapse22" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre </i></button>
                    </h4>
                  </div>
                  <div id="collapse22" class="panel-collapse collapse in" data-bs-parent="#accordion5">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo22()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion22()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs22, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue22($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo22">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820223()" data-bs-toggle="collapse" data-bs-parent="#accordion5"
                        href="#collapse23" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse23" class="panel-collapse collapse in" data-bs-parent="#accordion5">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo22()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion22()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs22, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue22($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo22">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820224()" data-bs-toggle="collapse" data-bs-parent="#accordion5"
                        href="#collapse24" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse24" class="panel-collapse collapse in" data-bs-parent="#accordion5">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo22()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion22()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs22, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue22($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo22">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>






              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#a6"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2023</i></button>
              </h4>
            </div>
            <div id="a6" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion6" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820231()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse21" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse21" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820232()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse22" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre </i></button>
                    </h4>
                  </div>
                  <div id="collapse22" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820233()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse23" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse23" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820234()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse24" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse24" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>






              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#a6s"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2024</i></button>
              </h4>
            </div>
            <div id="a6s" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion6" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820231s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse21s" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse21s" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820232s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse22s" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre </i></button>
                    </h4>
                  </div>
                  <div id="collapse22s" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820233s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse23s" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse23s" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820234s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse24s" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse24s" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>






              </div>
            </div>
          </div>



          <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#a6s2525"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2025</i></button>
              </h4>
            </div>
            <div id="a6s2525" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion6" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820251s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse25s" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse25s" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820252s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse25sf25" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre </i></button>
                    </h4>
                  </div>
                  <div id="collapse25sf25" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820253s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse25sk" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse25sk" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820254s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse25sc" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse25sc" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



  <div class="panel panel-default">
            <div class="panel-heading">
              <h4 class="panel-title">
                <button data-bs-toggle="collapse" data-bs-parent="#accordion" href="#a6s25256"
                  style="background: none; border: none;">
                  <i class="bi bi-folder-fill"> 2026</i></button>
              </h4>
            </div>
            <div id="a6s25256" class="panel-collapse collapse in" data-bs-parent="#accordion">
              <div class="panel-group" id="accordion6" style=" margin-left: 20px;">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820261s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse26s" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Primer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse26s" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>







                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820262s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse25sf26" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Segundo Trimestre </i></button>
                    </h4>
                  </div>
                  <div id="collapse25sf26" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820263s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse26sk" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Tercer Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse26sk" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <button (click)="ar820264s()" data-bs-toggle="collapse" data-bs-parent="#accordion6"
                        href="#collapse26sc" style="background: none; border: none;">
                        <i class="bi bi-folder-fill">Cuarto Trimestre</i></button>
                    </h4>
                  </div>
                  <div id="collapse26sc" class="panel-collapse collapse in" data-bs-parent="#accordion6">
                    <div class="panel-body">
                      <div style="margin: auto; width: 80%; height: 70px; display: flex; justify-content: right;"
                        *ngIf="boton === 1">
                        <button style="height: 38px;" (click)="seleccionarTodo23()" type="button"
                          class="btn btn-outline-dark">Seleccionar Todo</button>
                        <button style="height: 38px;  margin-left: 10px;" (click)="quitarSeleccion23()" type="button"
                          class="btn btn-outline-dark">Desahacer Selección</button>
                        <button style="height: 38px; margin-left: 10px;" (click)="eliminarSeleccionados()" type="button"
                          class="btn btn-outline-dark">Eliminar Seleccionados</button>
                      </div>
                      <div class="fondo">

                        <div id="scroll">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col"><img src="assets/img/file.png" alt="" height="30" width="30"> Nombre
                                  del
                                  documento</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr *ngFor="let dato of docs23, let i = index">
                                <td><input type="checkbox" (change)="checkCheckBoxvalue23($event, i, dato?.ID)"
                                    *ngIf="boton === 1" [checked]="todo23">
                                  <img src="assets/img/docs.png" alt="" height="30" width="30">
                                  <a [href]="dato?.ENLACE" target="_blank" style="text-align: end;">
                                    {{dato?.NOMBRE}}</a>
                                </td>
                                <td>
                                  <button *ngIf="boton === 1" (click)="eliminar(dato?.ID)" type="button"
                                    class="btn btn-outline-dark">Eliminar</button>
                                </td>

                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>





      </div>

        </div>
      </div>
    </section><!-- ======= Fin Seccion Carpetas por año ======= -->

  </main><!-- End #main -->


  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>

  <!-- Vendor JS Files -->
  <script src="/assets/vendor/aos/aos.js"></script>
  <script src="/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="/assets/vendor/glightbox/js/glightbox.min.js"></script>
  <script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="/assets/vendor/swiper/swiper-bundle.min.js"></script>
  <script src="/assets/vendor/waypoints/noframework.waypoints.js"></script>
  <script src="/assets/vendor/php-email-form/validate.js"></script>

  <!-- Template Main JS File -->
  <script src="/assets/js/main.js"></script>

</body>

</html>
